// import React from "react";
// import {
//   IconCheck,
//   IconPrinter,
//   IconDownload,
//   IconX,
// } from "@tabler/icons-react";

// interface OrderSuccessPreviewProps {
//   order: any;
//   onPrintAWB: () => void;
//   onPrintReceipt: () => void;
//   onClose: () => void;
//   fetchData: () => void;
// }

// const OrderSuccessPreview: React.FC<OrderSuccessPreviewProps> = ({
//   order,
//   onPrintAWB,
//   onPrintReceipt,
//   onClose,
//   fetchData,
// }) => {
//   return (
//     <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
//       <div className="bg-white rounded-2xl p-8 text-center max-w-lg mx-auto">
//         <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
//           <IconCheck size={48} className="text-green-600" />
//         </div>

//         <h2 className="text-3xl font-bold text-gray-900 mb-2">
//           Order Created Successfully!
//         </h2>
//         <p className="text-gray-600 mb-8">
//           Your order has been placed. You can now print the required documents.
//         </p>

//         {/* Order Summary */}
//         <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left">
//           <div className="grid grid-cols-2 gap-y-4 text-sm">
//             <div className="text-gray-500">Order Reference</div>
//             <div className="font-medium text-right">
//               {order?.referenceNumber || ""}
//             </div>

//             <div className="text-gray-500">Receiver</div>
//             <div className="font-medium text-right">
//               {order?.receiver?.name}
//             </div>

//             <div className="text-gray-500">Payment Type</div>
//             <div className="font-medium text-right">
//               {order?.shipment?.paymentType}
//             </div>

//             {order?.shipment?.codAmount && (
//               <>
//                 <div className="text-gray-500">COD Amount</div>
//                 <div className="font-medium text-right">
//                   ₹{order.shipment.codAmount}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         {/* Print Actions */}
//         <div className="space-y-4">
//           <button
//             onClick={onPrintAWB}
//             className="w-full flex items-center justify-center gap-3 bg-black text-white py-4 rounded-2xl hover:bg-gray-900 transition font-medium"
//           >
//             <IconPrinter size={22} />
//             Print AWB / Shipping Label
//           </button>

//           <button
//             onClick={onPrintReceipt}
//             className="w-full flex items-center justify-center gap-3 border-2 border-gray-300 py-4 rounded-2xl hover:bg-gray-50 transition font-medium"
//           >
//             <IconDownload size={22} />
//             Print Receipt / Invoice
//           </button>
//         </div>

//         <div className="mt-8 flex gap-4">
//           <button
//             onClick={() => {
//               fetchData();
//               onClose();
//             }}
//             className="flex-1 py-3 text-gray-600 border border-gray-300 rounded-2xl hover:bg-gray-50"
//           >
//             Close
//           </button>

//           <button
//             onClick={() => {
//               fetchData();
//               onClose();
//             }}
//             className="flex-1 py-3 bg-[#FBD037] hover:bg-yellow-400 text-black rounded-2xl font-medium"
//           >
//             Create Another Order
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderSuccessPreview;

import React from "react";
import { IconCheck, IconPrinter, IconDownload } from "@tabler/icons-react";

const url = process.env.REACT_APP_BASE_URL;
interface Props {
  order: any;
  onClose: () => void;
  fetchData: () => void;
  onCreateAnother: () => void;
}

const OrderSuccessPreview: React.FC<Props> = ({
  order,
  onClose,
  fetchData,
  onCreateAnother,
}) => {
  const [isDownloading, setIsDownloading] = React.useState(false);
  // const handlePrintAWB = async () => {
  //   try {
  //     const orderId = order?.order?.id;

  //     if (!orderId) {
  //       console.error("Order ID missing", order);
  //       return;
  //     }

  //     const response = await fetch(
  //       `${url}/api/outlet/order/${orderId}/generate/pdf?type=outlet`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         credentials: "include",
  //         body: JSON.stringify({
  //           system: "default",
  //           size: "4 x 6 inches",
  //         }),
  //       },
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to generate AWB");
  //     }

  //     const blob = await response.blob();

  //     const fileURL = window.URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = fileURL;
  //     a.download = `AWB_${orderId}.pdf`;
  //     a.click();

  //     window.URL.revokeObjectURL(fileURL);
  //   } catch (error: any) {
  //     console.error(error);
  //     alert(error.message || "Something went wrong");
  //   }
  // };

  const handlePrintAWB = async () => {
    try {
      setIsDownloading(true); // disable button

      const orderId = order?.order?.id;

      if (!orderId) {
        console.error("Order ID missing", order);
        setIsDownloading(false);
        return;
      }

      const response = await fetch(
        `${url}/api/outlet/order/${orderId}/generate/pdf?type=outlet`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            system: "default",
            size: "4 x 6 inches",
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to generate AWB");
      }

      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = fileURL;
      a.download = `AWB_${orderId}.pdf`;
      a.click();

      window.URL.revokeObjectURL(fileURL);

      // ⏱ Re-enable after 3 seconds
      setTimeout(() => {
        setIsDownloading(false);
      }, 3000);
    } catch (error: any) {
      console.error(error);
      alert(error.message || "Something went wrong");
      setIsDownloading(false);
    }
  };

  const handlePrintReceipt = () => {
    window.print();
  };

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-10 text-center max-w-lg mx-auto">
        <div className="mx-auto w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <IconCheck size={60} className="text-green-600" />
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Order Created Successfully
        </h2>
        <p className="text-gray-600 mb-8">
          Your order has been placed. Delivery agent will collect payment as
          selected.
        </p>

        <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-500">Payment Type</span>
            <span className="font-medium">
              {order?.shipment?.paymentType || ""}
            </span>
          </div>
          {(order?.shipment?.paymentType === "COD" ||
            order?.shipment?.paymentType === "CardOnDelivery") && (
            <div className="flex justify-between">
              <span className="text-gray-500">Amount to Collect</span>
              <span className="font-medium">₹{order.shipment.codAmount}</span>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <button
            onClick={handlePrintAWB}
            disabled={isDownloading}
            className={`w-full flex items-center justify-center gap-3 py-4 rounded-2xl font-medium 
    ${
      isDownloading
        ? "bg-gray-200 cursor-not-allowed"
        : "bg-black text-white hover:bg-gray-900"
    }`}
          >
            <IconPrinter size={24} />
            {isDownloading ? "Downloading..." : "Print AWB / Shipping Label"}
          </button>
          <button
            onClick={handlePrintReceipt}
            className="w-full flex items-center justify-center gap-3 border-2 border-gray-300 py-4 rounded-2xl font-medium hover:bg-gray-50"
          >
            <IconDownload size={24} /> Print Receipt
          </button>
        </div>

        <div className="mt-10 flex gap-4">
          <button
            onClick={() => {
              fetchData();
              onClose();
            }}
            className="flex-1 py-3 border border-gray-300 rounded-2xl font-medium"
          >
            Close
          </button>
          <button
            onClick={() => {
              fetchData();
              onCreateAnother();
            }}
            className="flex-1 py-3 bg-[#FBD037] hover:bg-yellow-400 text-black rounded-2xl font-medium"
          >
            Create Another Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPreview;
